import type { DropdownProps } from 'react-bootstrap';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

type Base = {
  icon: React.ReactNode;
  label: React.ReactNode;
  className?: string;
};

type LinkItem = Base & {
  to: string;
  onClick?: never;
};

type ActionItem = Base & {
  onClick: () => void;
  to?: never;
};

export type MenuItemProps = LinkItem | ActionItem;

type Divider = { type: 'divider'; key: string };
type Item = { type: 'item'; key: string } & MenuItemProps;
export type DropdownMenuEntry = Item | Divider;

export const DropdownMenuItem = ({ icon, label, className, ...rest }: MenuItemProps) => {
  // Link variant
  if ('to' in rest) {
    return (
      <Dropdown.Item as={Link} to={rest.to} className={className}>
        {icon} {label}
      </Dropdown.Item>
    );
  }

  // onClick variant
  return (
    <Dropdown.Item as="button" type="button" onClick={rest.onClick} className={className}>
      {icon} {label}
    </Dropdown.Item>
  );
};

type DropdownMenuProps = Omit<DropdownProps, 'children'> & {
  items: Array<DropdownMenuEntry>;
};

export const DropdownMenu = ({ items, ...props }: DropdownMenuProps) => {
  return (
    <Dropdown.Menu className="bg-white">
      {items.map((entry) => {
        if (entry.type === 'divider') return <Dropdown.Divider key={entry.key} />;

        const { type, key, ...itemProps } = entry;
        return <DropdownMenuItem key={key} {...itemProps} />;
      })}
    </Dropdown.Menu>
  );
};
